export default __webpack_public_path__ + "static/media/Seer_logo.b9e3da5d.png";